module.exports = __webpack_public_path__ + "static/cat-79cca84e930b7dbb05056184d6a0d9bd.jpg";